import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12 sm:py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://dathent.com/icon.png" 
                alt="Dathent Logo" 
                className="h-10 w-10"
              />
              <span className="text-2xl font-bold text-white">Dathent</span>
            </div>
            <p className="text-gray-400 mb-4">
              Автоматизация бизнеса с помощью AI-технологий. Чат-боты, CRM-интеграции, умные рассылки и лендинги.
            </p>
          </div>

          {/* Spain Office */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Офис в Испании</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <MapPin className="w-5 h-5 mr-2 mt-1 flex-shrink-0" />
                <span className="text-sm">Dathent Sax SLU (ES)<br />Avenida Reyes Católicos 9BAJO,<br />03630, Sax (Alicante), Spain</span>
              </div>
              <div className="flex items-center">
                <Phone className="w-5 h-5 mr-2 flex-shrink-0" />
                <a href="tel:+34865443750" className="hover:text-white transition-colors">+34 865 443 750</a>
              </div>
              <div className="flex items-center">
                <Mail className="w-5 h-5 mr-2 flex-shrink-0" />
                <a href="mailto:info@dathent.com" className="hover:text-white transition-colors">info@dathent.com</a>
              </div>
            </div>
          </div>

          {/* Czech Office */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Офис в Чехии</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <MapPin className="w-5 h-5 mr-2 mt-1 flex-shrink-0" />
                <span className="text-sm">Dathent s.r.o.<br />Zenklova 24/54,<br />180 00 Prague - Liben, Czech Republic</span>
              </div>
              <div className="flex items-center">
                <Phone className="w-5 h-5 mr-2 flex-shrink-0" />
                <a href="tel:+420777684036" className="hover:text-white transition-colors">+420 777 684 036</a>
              </div>
              <div className="flex items-center">
                <Mail className="w-5 h-5 mr-2 flex-shrink-0" />
                <a href="mailto:dathent_sro@lotrans.info" className="hover:text-white transition-colors">dathent_sro@lotrans.info</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © 2025 Dathent. Все права защищены.
            </div>
            <div className="flex space-x-6">
              <a 
                href="https://app.dathent.com/privacy" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm text-gray-400 hover:text-white transition-colors"
              >
                Privacy Policy
              </a>
              <a 
                href="https://t.me/AIchatbusinesbot" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm text-gray-400 hover:text-white transition-colors"
              >
                Telegram
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
